import { WarningRounded } from '@mui/icons-material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import {
  Link as MuiLink,
} from '@mui/material';
import React from 'react';
import { useRecordContext } from 'react-admin';

export function Link() {
  const record = useRecordContext() || {};
  const { url, title } = record;

  return (
    <MuiLink href={url} target="_blank" rel="noopener noreferrer">
      {title ? <OpenInNewRoundedIcon /> : <WarningRounded />}
    </MuiLink>
  );
}

Link.defaultProps = {
  label: 'Link',
};
